// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bib_jk","CommentListPlaceholder--Legacy":"ih_b bib_rc bib_wq"};